var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDatabase = function SvgDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "database_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#database_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M9.503 16.23q-2.883 0-4.806-.814-1.924-.813-1.924-2.033v-7.84q0-1.147 1.97-1.96 1.97-.811 4.76-.812 2.788 0 4.759.813 1.97.812 1.97 1.958v7.84q0 1.221-1.924 2.034-1.923.814-4.805.814m0-9.138q1.731 0 3.485-.49 1.755-.49 2.033-1.055-.27-.582-2.012-1.085a12.57 12.57 0 0 0-7.001-.014q-1.732.49-2.04 1.068.3.594 2.025 1.085 1.723.49 3.51.491m0 3.962q.823 0 1.603-.08.78-.079 1.49-.231t1.33-.378q.618-.225 1.118-.51V7.046q-.5.285-1.119.51-.62.226-1.33.378-.71.153-1.49.231-.778.08-1.602.08-.84 0-1.635-.083t-1.502-.236q-.706-.152-1.316-.373a6.4 6.4 0 0 1-1.09-.507v2.81q.48.284 1.09.506.61.221 1.316.373t1.502.236 1.635.082m0 3.988q.963 0 1.892-.127t1.69-.347a6.2 6.2 0 0 0 1.284-.51q.523-.292.675-.611v-2.404q-.5.285-1.119.51-.62.225-1.33.377-.71.153-1.49.232-.778.08-1.602.079-.84 0-1.635-.083t-1.502-.235a10 10 0 0 1-1.316-.374 6.4 6.4 0 0 1-1.09-.506v2.416q.153.326.67.608.517.28 1.278.501.762.22 1.696.347a14 14 0 0 0 1.899.127"
  }))));
};
export default SvgDatabase;